import React, { useRef, useState, useEffect, useCallback } from "react";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist";

GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const PdfViewer = ({ pdfUrl, height, objectFit }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isRendered, setIsRendered] = useState(false);
  const [error, setError] = useState(null);

  const renderPdfPage = useCallback(async (pdf, pageNumber, containerWidth) => {
    setIsRendered(false);
    const page = await pdf.getPage(pageNumber);
    const canvas = canvasRef.current;

    if (!canvas) return;

    const context = canvas.getContext("2d");

    const viewport = page.getViewport({ scale: 1.0 });
    const scale = containerWidth / viewport.width;
    const finalViewport = page.getViewport({ scale: scale });

    canvas.height = finalViewport.height;
    canvas.width = finalViewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: finalViewport,
    };
    await page.render(renderContext).promise;

    setIsRendered(true);
  }, []);

  useEffect(() => {
    let pdfDocument = null;
    let isCancelled = false;

    const loadAndRenderPdf = async () => {
      if (!pdfUrl) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      setIsRendered(false);

      const container = containerRef.current;
      const containerWidth = container ? container.clientWidth : 300;

      try {
        const loadingTask = getDocument(pdfUrl);
        pdfDocument = await loadingTask.promise;

        if (isCancelled) return;

        setNumPages(pdfDocument.numPages);

        await renderPdfPage(pdfDocument, currentPage, containerWidth);
      } catch (err) {
        if (isCancelled) return;
        setIsRendered(false);
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };

    loadAndRenderPdf();

    return () => {
      isCancelled = true;
      if (pdfDocument) {
        pdfDocument.destroy();
      }
    };
  }, [pdfUrl, currentPage, renderPdfPage]);

  return (
    <div className="PreCardd">
      <div
        // style={{ height: height }}
        ref={containerRef}
        className="PreCard-canvas"
      >
        <canvas
          ref={canvasRef}
          style={{
            visibility: isRendered ? "visible" : "hidden",
            objectFit: objectFit,
          }}
        />
      </div>
    </div>
  );
};

export default PdfViewer;
